import { Link } from 'react-router-dom';
import HeaderSv from '@/components/sv/HeaderSv';
import FooterSv from '@/components/sv/FooterSv';
import { Button } from '@/components/ui/button';

const NotFoundSv = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <HeaderSv />
      <main className="flex-grow flex items-center justify-center pt-20">
        <div className="text-center px-6 py-16">
          <h1 className="text-9xl font-bold text-electric-cyan mb-4">404</h1>
          <h2 className="text-4xl font-bold text-foreground mb-6">
            Sidan hittades inte
          </h2>
          <p className="text-xl text-muted-foreground mb-8 max-w-md mx-auto">
            Vi kunde inte hitta sidan du letar efter. Den kan ha flyttats eller tagits bort.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/sv/">
              <Button size="lg" className="min-w-[200px]">
                Gå till startsidan
              </Button>
            </Link>
            <Link to="/sv/about">
              <Button variant="outline" size="lg" className="min-w-[200px]">
                Kontakta oss
              </Button>
            </Link>
          </div>
        </div>
      </main>
      <FooterSv />
    </div>
  );
};

export default NotFoundSv;
